import wixSite from 'wix-site';
import {filterProducts,sortProducts,updateClicksOnObject} from 'public/productsListRepeater.js'; 
//import {filterOutSelectedPageFromMenu} from 'public/Menus.js'; 
import {runProgressBar} from 'public/selectedPageHeader.js'; 
//import wixData from 'wix-data';


$w.onReady(function () 
{
    runProgressBar($w('#pageProgressBar'),1500);  
    $w('#pageNameText').text = wixSite.currentPage.name;
   
    $w("#sortSpaProductDropdown").onChange(() =>
    {
        let selectedOption = $w("#sortSpaProductDropdown").options.find(o => o.value === $w("#sortSpaProductDropdown").value);
        let selectedLabel = selectedOption.label;

        if($w('#sortSpaProductDropdown').value == 'popularity')
            sortProducts($w('#dataset1'),$w('#sortSpaProductDropdown').value,'ClickCounter');	  
    
        else
            sortProducts($w('#dataset1'),$w('#sortSpaProductDropdown').value,'price');	  
        
        runProgressBar($w('#pageProgressBar'),1500);
    });

    $w("#filterSpaProductDropdown").onChange(() =>
    {
        if(Number($w('#filterSpaProductDropdown').value) == 1) filterProducts($w('#dataset1'),"filterByAmount",0, 2);
        else if(Number($w('#filterSpaProductDropdown').value) == 11) filterProducts($w('#dataset1'),"filterByAmount",10, 12);
        else if(Number($w('#filterSpaProductDropdown').value) == 22) filterProducts($w('#dataset1'),"filterByAmount",21, 34);
        else filterProducts($w('#dataset1'),"filterByAmount",0, 100);
        runProgressBar($w('#pageProgressBar'),1500);
    });
});

// Click counter triggers.
export function spaProductImage_click(event) { updateClicksOnObject(event); }
export function whatsappButton_click(event) { updateClicksOnObject(event); }
export function priceButton_click(event) { updateClicksOnObject(event); }
export function durationButton_click(event) { updateClicksOnObject(event); }


export function selectedPageDropdown_change(event) 
{  
    let selectedOption = $w("#sortSpaProductDropdown").options.find(o => o.value === $w("#sortSpaProductDropdown").value);
    let selectedLabel = selectedOption.label;

    if($w('#sortSpaProductDropdown').value == 'popularity')
        sortProducts($w('#dataset1'),$w('#sortSpaProductDropdown').value,'ClickCounter');	  
    
    else
        sortProducts($w('#dataset1'),$w('#sortSpaProductDropdown').value,'price');	  
        
    runProgressBar($w('#pageProgressBar'),1500);
}